import { render, staticRenderFns } from "./LedgerCard.vue?vue&type=template&id=bad9ef2a"
import script from "./LedgerCard.vue?vue&type=script&lang=js"
export * from "./LedgerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports